/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { I18nInfo } from './I18nInfo';
import {
    instanceOfI18nInfo,
    I18nInfoFromJSON,
    I18nInfoFromJSONTyped,
    I18nInfoToJSON,
} from './I18nInfo';

/**
 * @type AbpPtwExceptionHttpResponseModelOfPtwErrorExceptionDetailsI18n
 * 
 * @export
 */
export type AbpPtwExceptionHttpResponseModelOfPtwErrorExceptionDetailsI18n = I18nInfo;


export function AbpPtwExceptionHttpResponseModelOfPtwErrorExceptionDetailsI18nFromJSON(json: any): AbpPtwExceptionHttpResponseModelOfPtwErrorExceptionDetailsI18n {
    return AbpPtwExceptionHttpResponseModelOfPtwErrorExceptionDetailsI18nFromJSONTyped(json, false);
}

export function AbpPtwExceptionHttpResponseModelOfPtwErrorExceptionDetailsI18nFromJSONTyped(json: any, ignoreDiscriminator: boolean): AbpPtwExceptionHttpResponseModelOfPtwErrorExceptionDetailsI18n {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...I18nInfoFromJSONTyped(json, true) };
    return  I18nInfoFromJSONTyped(json, true);
}

export function AbpPtwExceptionHttpResponseModelOfPtwErrorExceptionDetailsI18nToJSON(value?: AbpPtwExceptionHttpResponseModelOfPtwErrorExceptionDetailsI18n | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfI18nInfo(value)) {
        return I18nInfoToJSON(value as I18nInfo);
    }

    return {};
}

/**
 * Check if a given object implements the AbpPtwExceptionHttpResponseModelOfPtwErrorExceptionDetailsI18n interface.
 */
export function instanceOfAbpPtwExceptionHttpResponseModelOfPtwErrorExceptionDetailsI18n(value: any): value is AbpPtwExceptionHttpResponseModelOfPtwErrorExceptionDetailsI18n {
    if (instanceOfI18nInfo(value)) return true;
    return false;
}

